const ROUTE_PATHS = {
  LANDING_PAGE: "/",
  LOGIN: "/login",
  TRACK_NON_LOGIN: "/track-non-login",
  TRACK: "/track",
  CREATE_ORDER: "/create-order",
  CREATE_SINGLE_ORDER: "/create-order/order",
  EDIT_ORDER : '/edit-order',
  BULK_ORDER: "/bulk-order",
  HISTORY: "/history",
  ORDER_DETAILS: "/order-details",
  IMPORT_LIST: "/import-list",
  PROFILE: "/profile",
  MY_PROFILE: "/my-profile",
  PREFERENCES: "/preferences",
  SECURITY_LOGIN: "/security-login",
  NO_PERMISSION: "/noPermission",
};
export default ROUTE_PATHS;
